window.AdminContent = function AdminContent({ showNotification }) {
  const [activeSubTab, setActiveSubTab] = React.useState('nav_menu');
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const tabsRef = React.useRef(null);

  const handleScrollTabs = (dir) => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: dir === 'left' ? -200 : 200, behavior: 'smooth' });
    }
  };

  // 0. Navbar & Menu Items (Add/Edit/Hide/Show/Delete/Reorder)
  const [navMenu, setNavMenu] = React.useState([
    { id: 'home', label: 'Home', target: 'home', type: 'link', visible: true },
    { 
      id: 'industries', 
      label: 'Industries', 
      target: 'industries', 
      type: 'dropdown', 
      visible: true,
      items: [
        { id: 'railway', label: 'Railway Testing Systems & Rigs', target: 'railway', visible: true },
        { id: 'automotive', label: 'Automotive Test & Automation', target: 'automotive', visible: true },
        { id: 'aerospace', label: 'Aerospace Test Systems & GSE', target: 'aerospace', visible: true },
        { id: 'industrial', label: 'Industrial Automation & SPM', target: 'industrial', visible: true },
        { id: 'rd', label: 'R&D & Academic Research', target: 'rd', visible: true }
      ]
    },
    { id: 'products', label: 'Products', target: 'products', type: 'link', visible: true },
    { id: 'projects', label: 'Projects', target: 'projects', type: 'link', visible: true },
    { id: 'about', label: 'About', target: 'about', type: 'link', visible: true },
    { id: 'blogs', label: 'Blogs', target: 'blogs', type: 'link', visible: true },
    { id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true },
    { id: 'india', label: 'Proudly Indian', target: 'india', type: 'link', visible: true },
    { id: 'downloads', label: 'Downloads', target: 'downloads', type: 'link', visible: true },
    { id: 'contact', label: 'Contact / RFQ', target: 'contact', type: 'link', visible: true }
  ]);

  // 1. Solutions List (Full CRUD)
  const [solutionsData, setSolutionsData] = React.useState([]);

  // 2. Industries List (Full CRUD)
  const [industriesData, setIndustriesData] = React.useState([]);

  // 2b. India Page Content
  const [indiaPage, setIndiaPage] = React.useState({
    subtitle: "",
    quote: "",
    bgImage: "",
    lionLogo: ""
  });

  // 3. Hero Carousel (Add/Edit/Delete/Reorder)
  const [heroSlides, setHeroSlides] = React.useState([]);

  // 4. Client Logos & Organizations (Add/Edit/Delete/Reorder by Sector)
  const [clientsData, setClientsData] = React.useState({
    railways: [],
    automotive: [],
    rd: [],
    aerospace: []
  });

  // 5. 8-Stage Engineering Process
  const [processSteps, setProcessSteps] = React.useState([]);

  // 6. Leadership & Engineering Team
  const [teamMembers, setTeamMembers] = React.useState([]);

  // 7. Positioning & Stats
  const [positioning, setPositioning] = React.useState({
    eyebrow: "",
    h1: "",
    statement: "",
    stats: {
      years: "",
      projects: "",
      sectors: "",
      systems: "",
      clients: ""
    }
  });

  // 8. About FAQs & About Page
  const [faqs, setFaqs] = React.useState([]);

  const [aboutPage, setAboutPage] = React.useState({
    hero: {
      bgImage: "",
      eyebrow: "",
      titleWhite: "",
      titleBlueLine1: "",
      titleBlueLine2: "",
      description: ""
    },
    pillars: {
      title: "",
      subtitle: "",
      items: []
    }
  });

  // 9. Contact & Footer
  const [contactInfo, setContactInfo] = React.useState({
    address: "",
    phone: "",
    phone2: "",
    whatsapp: "",
    email: "",
    supportEmail: "",
    workingHours: ""
  });

  const [footerInfo, setFooterInfo] = React.useState({
    tagline: "",
    legal: ""
  });

  const [productCategories, setProductCategories] = React.useState([]);

  // Modals state for Add / Edit
  const [editingNavItem, setEditingNavItem] = React.useState(null);
  const [editingSolution, setEditingSolution] = React.useState(null);
  const [editingIndustry, setEditingIndustry] = React.useState(null);
  const [editingSlide, setEditingSlide] = React.useState(null);
  const [editingClient, setEditingClient] = React.useState(null);
  const [editingStep, setEditingStep] = React.useState(null);
  const [editingMember, setEditingMember] = React.useState(null);
  const [editingFaq, setEditingFaq] = React.useState(null);
  const [mediaPickerConfig, setMediaPickerConfig] = React.useState({ isOpen: false, onSelect: null, title: 'Choose Image' });

  const mergeNavMenu = (loadedMenu) => {
    const defaultNavMenu = [
      { id: 'home', label: 'Home', target: 'home', type: 'link', visible: true },
      { 
        id: 'industries', 
        label: 'Industries', 
        target: 'industries', 
        type: 'dropdown', 
        visible: true,
        items: [
          { id: 'railway', label: 'Railway Testing Systems & Rigs', target: 'railway', visible: true },
          { id: 'automotive', label: 'Automotive Test & Automation', target: 'automotive', visible: true },
          { id: 'aerospace', label: 'Aerospace Test Systems & GSE', target: 'aerospace', visible: true },
          { id: 'industrial', label: 'Industrial Automation & SPM', target: 'industrial', visible: true },
          { id: 'rd', label: 'R&D & Academic Research', target: 'rd', visible: true }
        ]
      },
      { id: 'products', label: 'Products', target: 'products', type: 'link', visible: true },
      { id: 'projects', label: 'Projects', target: 'projects', type: 'link', visible: true },
      { id: 'about', label: 'About', target: 'about', type: 'link', visible: true },
      { id: 'blogs', label: 'Insights', target: 'blogs', type: 'link', visible: true },
      { id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true },
      { id: 'india', label: 'Proudly Indian', target: 'india', type: 'link', visible: true },
      { id: 'downloads', label: 'Downloads', target: 'downloads', type: 'link', visible: true },
      { id: 'contact', label: 'Contact / RFQ', target: 'contact', type: 'link', visible: true }
    ];

    if (!Array.isArray(loadedMenu) || loadedMenu.length === 0) return defaultNavMenu;
    const merged = [...loadedMenu];
    
    // Check if careers is missing
    if (!merged.some(item => item.id === 'careers')) {
      const downloadsIdx = merged.findIndex(item => item.id === 'downloads');
      if (downloadsIdx !== -1) {
        merged.splice(downloadsIdx, 0, { id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true });
      } else {
        merged.push({ id: 'careers', label: 'Careers', target: 'careers', type: 'link', visible: true });
      }
    }
    
    // Check if india is missing
    if (!merged.some(item => item.id === 'india')) {
      const downloadsIdx = merged.findIndex(item => item.id === 'downloads');
      if (downloadsIdx !== -1) {
        merged.splice(downloadsIdx, 0, { id: 'india', label: 'Proudly Indian', target: 'india', type: 'link', visible: true });
      } else {
        merged.push({ id: 'india', label: 'Proudly Indian', target: 'india', type: 'link', visible: true });
      }
    }
    return merged;
  };
  // Lock body and main content scroll when any modal is open
  React.useEffect(() => {
    const mainEl = document.querySelector('main');
    const isAnyModalOpen = editingNavItem || editingSolution || editingIndustry || 
                           editingSlide || editingMember || editingStep || 
                           editingClient || mediaPickerConfig.isOpen;
    if (isAnyModalOpen) {
      document.body.style.overflow = 'hidden';
      if (mainEl) mainEl.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
      if (mainEl) mainEl.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'unset';
      if (mainEl) mainEl.style.overflow = 'auto';
    };
  }, [editingNavItem, editingSolution, editingIndustry, editingSlide, editingMember, editingStep, editingClient, mediaPickerConfig.isOpen]);

  const fetchProductCategories = async () => {
    try {
      const res = await window.apiClient.get('categories.php');
      if (res.success && res.data) {
        setProductCategories(res.data);
      }
    } catch (e) {
      console.warn('Failed to fetch categories:', e);
    }
  };

  // Fetch live CMS data on load
  React.useEffect(() => {
    fetchCmsData();
    fetchProductCategories();
  }, []);

  const fetchCmsData = async () => {
    try {
      setLoading(true);
      const res = await window.apiClient.get('content.php');
      if (res.success && res.data) {
        if (res.data.nav_menu && Array.isArray(res.data.nav_menu) && res.data.nav_menu.length > 0) {
          setNavMenu(mergeNavMenu(res.data.nav_menu));
        }
        if (res.data.solutions_data && Array.isArray(res.data.solutions_data) && res.data.solutions_data.length > 0) setSolutionsData(res.data.solutions_data);
        if (res.data.industries_data && Array.isArray(res.data.industries_data) && res.data.industries_data.length > 0) setIndustriesData(res.data.industries_data);
        if (res.data.home_hero && Array.isArray(res.data.home_hero) && res.data.home_hero.length > 0) setHeroSlides(res.data.home_hero);
        if (res.data.home_clients && typeof res.data.home_clients === 'object') setClientsData(res.data.home_clients);
        if (res.data.home_process && Array.isArray(res.data.home_process)) setProcessSteps(res.data.home_process);
        if (res.data.about_team && Array.isArray(res.data.about_team)) setTeamMembers(res.data.about_team);
        if (res.data.home_positioning) setPositioning(res.data.home_positioning);
        if (res.data.about_faqs && Array.isArray(res.data.about_faqs)) setFaqs(res.data.about_faqs);
        if (res.data.india_page) setIndiaPage(res.data.india_page);
        if (res.data.contact_info) setContactInfo(res.data.contact_info);
        if (res.data.footer_info) setFooterInfo(res.data.footer_info);
        if (res.data.about_page && res.data.about_page.hero && res.data.about_page.pillars) setAboutPage(res.data.about_page);
      }
    } catch (e) {
      console.warn('CMS fetch fallback:', e);
    } finally {
      setLoading(false);
    }
  };

  const saveSection = async (sectionKey, payloadData, successMsg = 'Saved successfully!') => {
    try {
      setSaving(true);
      const res = await window.apiClient.post('content.php', {
        section_key: sectionKey,
        content: payloadData
      });
      if (res.success) {
        showNotification(successMsg, 'success');
        window.dispatchEvent(new Event('novatek_content_updated'));
      } else {
        showNotification(res.message || 'Error saving data', 'error');
      }
    } catch (e) {
      showNotification(e.message || 'Server connection error', 'error');
    } finally {
      setSaving(false);
    }
  };

  // Image Upload helper
  const handleUploadImage = async (e, onUrlReceived) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('subfolder', 'banners');
      showNotification('Uploading image...', 'info');
      const res = await window.apiClient.uploadFile('upload.php', formData);
      if (res.success && res.url) {
        onUrlReceived(res.url);
        showNotification('Image uploaded successfully!', 'success');
      } else {
        showNotification(res.message || 'Upload failed', 'error');
      }
    } catch (err) {
      showNotification(err.message || 'Upload connection error', 'error');
    }
  };

  // ----------------------------------------------------
  // NAVIGATION MENU ACTIONS
  // ----------------------------------------------------
  const handleToggleNavVisibility = (index) => {
    const updated = [...navMenu];
    updated[index].visible = updated[index].visible === false ? true : false;
    setNavMenu(updated);
    saveSection('nav_menu', updated, `Navbar item "${updated[index].label}" ${updated[index].visible ? 'enabled' : 'hidden'}`);
  };

  const handleMoveNavItem = (index, dir) => {
    const targetIdx = index + dir;
    if (targetIdx < 0 || targetIdx >= navMenu.length) return;
    const updated = [...navMenu];
    const temp = updated[index];
    updated[index] = updated[targetIdx];
    updated[targetIdx] = temp;
    setNavMenu(updated);
    saveSection('nav_menu', updated, 'Navigation order updated!');
  };

  const handleDeleteNavItem = (index) => {
    if (!window.confirm(`Delete menu item "${navMenu[index].label}"?`)) return;
    const updated = navMenu.filter((_, i) => i !== index);
    setNavMenu(updated);
    saveSection('nav_menu', updated, 'Navigation item deleted!');
  };

  const handleSaveNavItem = () => {
    if (!editingNavItem || !editingNavItem.data.label) {
      showNotification('Item label is required.', 'error');
      return;
    }
    let updated;
    if (editingNavItem.index !== undefined) {
      updated = [...navMenu];
      updated[editingNavItem.index] = editingNavItem.data;
    } else {
      updated = [...navMenu, editingNavItem.data];
    }
    setNavMenu(updated);
    saveSection('nav_menu', updated, 'Navigation menu updated!');
    setEditingNavItem(null);
  };

  const updateEditingSolution = (changes) => {
    setEditingSolution(prev => prev ? { ...prev, data: { ...prev.data, ...changes } } : prev);
  };

  const updateEditingIndustry = (changes) => {
    setEditingIndustry(prev => prev ? { ...prev, data: { ...prev.data, ...changes } } : prev);
  };

  // ----------------------------------------------------
  // SOLUTIONS CRUD ACTIONS
  // ----------------------------------------------------
  const handleToggleSolutionVisibility = (index) => {
    const updated = [...solutionsData];
    updated[index].visible = updated[index].visible === false ? true : false;
    setSolutionsData(updated);
    saveSection('solutions_data', updated, `Category "${updated[index].title}" ${updated[index].visible ? 'published' : 'hidden'}`);
  };

  const handleMoveSolution = (index, dir) => {
    const targetIdx = index + dir;
    if (targetIdx < 0 || targetIdx >= solutionsData.length) return;
    const updated = [...solutionsData];
    const temp = updated[index];
    updated[index] = updated[targetIdx];
    updated[targetIdx] = temp;
    setSolutionsData(updated);
    saveSection('solutions_data', updated, 'Categories order updated!');
  };

  const handleDeleteSolution = (index) => {
    if (!window.confirm(`Delete Category "${solutionsData[index].title}"?`)) return;
    const updated = solutionsData.filter((_, i) => i !== index);
    setSolutionsData(updated);
    saveSection('solutions_data', updated, 'Category deleted!');
  };

  const handleSaveSolution = () => {
    if (!editingSolution || !editingSolution.data.title) {
      showNotification('Category title is required.', 'error');
      return;
    }
    let updated;
    const solutionPayload = {
      ...editingSolution.data,
      focusAreas: editingSolution.data.focusAreas || [],
      testTypes: editingSolution.data.testTypes || [],
      technologies: editingSolution.data.technologies || [],
      relatedProducts: editingSolution.data.relatedProducts || []
    };

    if (editingSolution.index !== undefined) {
      updated = [...solutionsData];
      updated[editingSolution.index] = solutionPayload;
    } else {
      updated = [...solutionsData, solutionPayload];
    }
    setSolutionsData(updated);
        saveSection('solutions_data', updated, 'Category saved successfully!');
    setEditingSolution(null);
  };

  // ----------------------------------------------------
  // INDUSTRIES CRUD ACTIONS
  // ----------------------------------------------------
  const handleToggleIndustryVisibility = (index) => {
    const updated = [...industriesData];
    updated[index].visible = updated[index].visible === false ? true : false;
    setIndustriesData(updated);
    saveSection('industries_data', updated, `Industry "${updated[index].title}" ${updated[index].visible ? 'published' : 'hidden'}`);
  };

  const handleMoveIndustry = (index, dir) => {
    const targetIdx = index + dir;
    if (targetIdx < 0 || targetIdx >= industriesData.length) return;
    const updated = [...industriesData];
    const temp = updated[index];
    updated[index] = updated[targetIdx];
    updated[targetIdx] = temp;
    setIndustriesData(updated);
    saveSection('industries_data', updated, 'Industries order updated!');
  };

  const handleDeleteIndustry = (index) => {
    if (!window.confirm(`Delete Industry "${industriesData[index].title}"?`)) return;
    const updated = industriesData.filter((_, i) => i !== index);
    setIndustriesData(updated);
    saveSection('industries_data', updated, 'Industry deleted!');
  };

  const handleSaveIndustry = () => {
    if (!editingIndustry || !editingIndustry.data.title) {
      showNotification('Industry title is required.', 'error');
      return;
    }
    let updated;
    const industryPayload = {
      ...editingIndustry.data,
      subSectors: editingIndustry.data.subSectors || [],
      challengesSolved: editingIndustry.data.challengesSolved || [],
      featuredProducts: editingIndustry.data.featuredProducts || []
    };

    if (editingIndustry.index !== undefined) {
      updated = [...industriesData];
      updated[editingIndustry.index] = industryPayload;
    } else {
      updated = [...industriesData, industryPayload];
    }
    setIndustriesData(updated);
    saveSection('industries_data', updated, 'Industry saved successfully!');
    setEditingIndustry(null);
  };

  // ----------------------------------------------------
  // HERO SLIDES ACTIONS
  // ----------------------------------------------------
  const handleMoveSlide = (index, dir) => {
    const targetIdx = index + dir;
    if (targetIdx < 0 || targetIdx >= heroSlides.length) return;
    const updated = [...heroSlides];
    const temp = updated[index];
    updated[index] = updated[targetIdx];
    updated[targetIdx] = temp;
    setHeroSlides(updated);
    saveSection('home_hero', updated, 'Slide order updated!');
  };

  const handleDeleteSlide = (index) => {
    if (!window.confirm(`Are you sure you want to delete slide #${index + 1}?`)) return;
    const updated = heroSlides.filter((_, i) => i !== index);
    setHeroSlides(updated);
    saveSection('home_hero', updated, 'Slide deleted successfully!');
  };

  const handleSaveSlide = () => {
    if (!editingSlide) return;
    let updated;
    if (editingSlide.index !== undefined) {
      updated = [...heroSlides];
      updated[editingSlide.index] = editingSlide.data;
    } else {
      updated = [...heroSlides, editingSlide.data];
    }
    setHeroSlides(updated);
    saveSection('home_hero', updated, 'Hero slides updated!');
    setEditingSlide(null);
  };

  // ----------------------------------------------------
  // CLIENT LOGOS ACTIONS
  // ----------------------------------------------------
  const handleDeleteClient = (sector, index) => {
    if (!window.confirm('Delete this client logo?')) return;
    const updatedSector = clientsData[sector].filter((_, i) => i !== index);
    const updatedAll = { ...clientsData, [sector]: updatedSector };
    setClientsData(updatedAll);
    saveSection('home_clients', updatedAll, 'Client removed!');
  };

  const handleSaveClient = () => {
    if (!editingClient) return;
    const { sector, index, data } = editingClient;
    const currentList = clientsData[sector] || [];
    let updatedSector;
    if (index !== undefined) {
      updatedSector = [...currentList];
      updatedSector[index] = data;
    } else {
      updatedSector = [...currentList, data];
    }
    const updatedAll = { ...clientsData, [sector]: updatedSector };
    setClientsData(updatedAll);
    saveSection('home_clients', updatedAll, 'Client saved!');
    setEditingClient(null);
  };

  // ----------------------------------------------------
  // PROCESS STEPS ACTIONS
  // ----------------------------------------------------
  const handleMoveStep = (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= processSteps.length) return;
    const updated = [...processSteps];
    const temp = updated[index];
    updated[index] = updated[target];
    updated[target] = temp;
    setProcessSteps(updated);
    saveSection('home_process', updated, 'Process step reordered!');
  };

  const handleDeleteStep = (index) => {
    if (!window.confirm(`Delete step #${processSteps[index].step}?`)) return;
    const updated = processSteps.filter((_, i) => i !== index);
    setProcessSteps(updated);
    saveSection('home_process', updated, 'Process step deleted!');
  };

  const handleSaveStep = () => {
    if (!editingStep) return;
    let updated;
    if (editingStep.index !== undefined) {
      updated = [...processSteps];
      updated[editingStep.index] = editingStep.data;
    } else {
      updated = [...processSteps, editingStep.data];
    }
    setProcessSteps(updated);
    saveSection('home_process', updated, 'Process step saved!');
    setEditingStep(null);
  };

  // ----------------------------------------------------
  // TEAM MEMBERS ACTIONS
  // ----------------------------------------------------
  const handleMoveMember = (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= teamMembers.length) return;
    const updated = [...teamMembers];
    const temp = updated[index];
    updated[index] = updated[target];
    updated[target] = temp;
    setTeamMembers(updated);
    saveSection('about_team', updated, 'Team order updated!');
  };

  const handleDeleteMember = (index) => {
    if (!window.confirm(`Delete team member "${teamMembers[index].name}"?`)) return;
    const updated = teamMembers.filter((_, i) => i !== index);
    setTeamMembers(updated);
    saveSection('about_team', updated, 'Team member deleted!');
  };

  const handleSaveMember = () => {
    if (!editingMember) return;
    let updated;
    if (editingMember.index !== undefined) {
      updated = [...teamMembers];
      updated[editingMember.index] = editingMember.data;
    } else {
      updated = [...teamMembers, editingMember.data];
    }
    setTeamMembers(updated);
    saveSection('about_team', updated, 'Team member saved!');
    setEditingMember(null);
  };

  // ----------------------------------------------------
  // FAQS ACTIONS
  // ----------------------------------------------------
  const handleDeleteFaq = (index) => {
    if (!window.confirm('Delete this FAQ?')) return;
    const updated = faqs.filter((_, i) => i !== index);
    setFaqs(updated);
    saveSection('about_faqs', updated, 'FAQ deleted!');
  };

  const handleSaveFaq = () => {
    if (!editingFaq) return;
    let updated;
    if (editingFaq.index !== undefined) {
      updated = [...faqs];
      updated[editingFaq.index] = editingFaq.data;
    } else {
      updated = [...faqs, editingFaq.data];
    }
    setFaqs(updated);
    saveSection('about_faqs', updated, 'FAQ saved!');
    setEditingFaq(null);
  };

  return (
    <div className="space-y-6">
      
      {/* Header Banner */}
      <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-xl font-sans font-bold text-slate-900">Website Content Management System</h2>
          <p className="text-xs font-sans text-slate-500 mt-1">
            Dynamic content control for Navigation Menu, Solutions, Industries, Hero Carousel, Client Logos, Team, Process, and Brand Positioning.
          </p>
        </div>
        <div className="flex items-center gap-2">
          {saving && (
            <span className="text-xs font-sans font-bold text-secondary flex items-center gap-1 animate-pulse">
              <span className="material-symbols-outlined text-sm animate-spin">sync</span>
              Saving to MySQL Database...
            </span>
          )}
        </div>
      </div>

      {/* Premium Sub-Tab Navigation Bar with Scroll Arrows */}
      <div className="relative border-b border-slate-200 flex items-center bg-white">
        <button 
          onClick={() => handleScrollTabs('left')}
          className="absolute left-0 z-10 px-2 bg-gradient-to-r from-white via-white to-transparent text-slate-400 hover:text-secondary h-full flex items-center justify-center cursor-pointer"
        >
          <span className="material-symbols-outlined text-xl drop-shadow-sm">chevron_left</span>
        </button>

        <div ref={tabsRef} className="flex overflow-x-auto pb-[1px] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] w-full px-8 scroll-smooth">
          {[
            { id: 'nav_menu', label: 'Navbar Menu Manager', icon: 'menu_open' },
            { id: 'home_hero', label: 'Hero Carousel', icon: 'view_carousel' },
            { id: 'india_page', label: 'Proudly Indian Page', icon: 'flag' },
            { id: 'home_clients', label: 'Client Logos', icon: 'verified' },
            { id: 'about_page', label: 'About Page', icon: 'info' },
            { id: 'about_team', label: 'Leadership & Team', icon: 'group' },
            { id: 'home_process', label: '8-Step Engineering Process', icon: 'timeline' },
            { id: 'home_positioning', label: 'Positioning & Stats', icon: 'analytics' },
            { id: 'about_faqs', label: 'Engineering FAQs', icon: 'quiz' },
            { id: 'contact_footer', label: 'Contact & Footer Info', icon: 'contact_support' }
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`px-5 py-3 font-sans text-xs font-bold transition-all whitespace-nowrap flex items-center gap-2 cursor-pointer border-b-2 ${
                activeSubTab === tab.id
                  ? 'border-secondary text-secondary bg-orange-50/50'
                  : 'border-transparent text-slate-500 hover:text-slate-800 hover:bg-slate-50'
              }`}
            >
              <span className="material-symbols-outlined text-[18px]">{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        <button 
          onClick={() => handleScrollTabs('right')}
          className="absolute right-0 z-10 px-2 bg-gradient-to-l from-white via-white to-transparent text-slate-400 hover:text-secondary h-full flex items-center justify-center cursor-pointer"
        >
          <span className="material-symbols-outlined text-xl drop-shadow-sm">chevron_right</span>
        </button>
      </div>

      {/* TAB 0: NAVBAR MENU MANAGER */}
      {activeSubTab === 'nav_menu' && (
        <div className="space-y-6">
          <div className="flex justify-between items-center bg-white p-4 rounded-2xl border border-slate-200">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">Header Navigation Bar Options</h3>
              <p className="font-sans text-xs text-slate-500">Hide/Show, edit labels, reorder, or add custom menu options that appear in the top navbar.</p>
            </div>
            <button
              onClick={() => setEditingNavItem({ data: { id: `nav-${Date.now()}`, label: 'New Link', target: 'home', type: 'link', visible: true } })}
              className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-4 py-2 rounded-xl flex items-center gap-1.5 shadow cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add Nav Item</span>
            </button>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
            <div className="divide-y divide-slate-100">
              {navMenu.map((item, idx) => (
                <div key={item.id} className="p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 hover:bg-slate-50 transition-colors">
                  <div className="flex items-center gap-3">
                    <span className="h-7 w-7 rounded-lg bg-slate-100 text-slate-600 font-sans font-bold text-xs flex items-center justify-center">
                      {idx + 1}
                    </span>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="font-sans text-sm font-bold text-slate-900">{item.label}</span>
                        <span className={`text-[10px] font-sans font-bold px-2 py-0.5 rounded-full ${
                          item.visible !== false ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'
                        }`}>
                          {item.visible !== false ? 'Visible on Website' : 'Hidden'}
                        </span>
                        <span className="text-[10px] font-sans px-2 py-0.5 rounded bg-slate-100 text-slate-500 uppercase">
                          {item.type}
                        </span>
                      </div>
                      <p className="font-sans text-xs text-slate-500 mt-0.5">
                        Target Tab: <span className="font-bold text-slate-700">{item.target}</span>
                        {item.items && ` • ${item.items.length} Dropdown Options`}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 shrink-0">
                    <button
                      onClick={() => handleToggleNavVisibility(idx)}
                      className={`px-3 py-1.5 rounded-lg font-sans text-xs font-bold transition-all flex items-center gap-1 cursor-pointer ${
                        item.visible !== false 
                          ? 'bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200' 
                          : 'bg-green-50 text-green-700 hover:bg-green-100 border border-green-200'
                      }`}
                    >
                      <span className="material-symbols-outlined text-sm">{item.visible !== false ? 'visibility_off' : 'visibility'}</span>
                      <span>{item.visible !== false ? 'Hide' : 'Show'}</span>
                    </button>

                    <button
                      onClick={() => handleMoveNavItem(idx, -1)}
                      disabled={idx === 0}
                      className="p-1.5 rounded-lg border hover:bg-slate-100 disabled:opacity-30 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-sm">arrow_upward</span>
                    </button>
                    <button
                      onClick={() => handleMoveNavItem(idx, 1)}
                      disabled={idx === navMenu.length - 1}
                      className="p-1.5 rounded-lg border hover:bg-slate-100 disabled:opacity-30 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-sm">arrow_downward</span>
                    </button>

                    <button
                      onClick={() => setEditingNavItem({ index: idx, data: { ...item } })}
                      className="bg-slate-900 text-white font-sans text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-secondary cursor-pointer"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteNavItem(idx)}
                      className="text-red-500 hover:text-red-700 p-1.5 rounded-lg hover:bg-red-50 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-base">delete</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* TAB 3: HERO CAROUSEL */}
      {activeSubTab === 'home_hero' && (
        <div className="space-y-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">Homepage Hero Carousel Slides</h3>
              <p className="font-sans text-xs text-slate-500">Each slide features targeted engineering positioning, messaging, challenge/solution callouts, CTAs, and background imagery.</p>
            </div>
            <button
              onClick={() => setEditingSlide({
                data: {
                  sector: "NEW SECTOR TEST RIGS",
                  h1: "Engineering Headline for Critical Industry",
                  description: "Novatek designs and manufactures custom test rigs and automated validation systems...",
                  bgImage: "/api/storage/banners/hero_railways.png",
                  primaryCta: "Explore Systems",
                  linkSlug: "solutions",
                  secondaryCta: "Request Engineering Consultation",
                  problem: "Eliminating testing bottlenecks and component failure risks in mission-critical applications.",
                  solution: "Turnkey electro-hydraulic, pneumatic, and servo-electric automated test systems."
                }
              })}
              className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-4 py-2.5 rounded-xl flex items-center gap-1.5 shadow shadow-orange-500/20 cursor-pointer shrink-0"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add Hero Slide</span>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {heroSlides.map((slide, idx) => (
              <div key={idx} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-all flex flex-col justify-between">
                <div>
                  {/* Thumbnail Banner */}
                  <div className="h-40 bg-slate-950 relative overflow-hidden">
                    <img
                      src={window.resolveMediaUrl(slide.bgImage, 'banner')}
                      alt={slide.sector}
                      onError={(e) => window.handleImageError(e, 'banner')}
                      className="w-full h-full object-cover opacity-80"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent"></div>
                    <span className="absolute top-3 left-3 bg-slate-900/90 text-secondary text-[11px] font-mono font-bold px-2.5 py-0.5 rounded border border-orange-500/30">
                      Slide #{idx + 1} • {slide.sector}
                    </span>
                  </div>

                  {/* Content Info */}
                  <div className="p-5 space-y-2.5">
                    <h4 className="font-sans text-base font-bold text-slate-900 line-clamp-1">{slide.h1}</h4>
                    <p className="font-sans text-xs text-slate-600 line-clamp-2">{slide.description}</p>
                    
                    <div className="grid grid-cols-2 gap-2 pt-2 text-[11px] font-sans">
                      <div className="bg-orange-50/70 p-2 rounded-lg border border-orange-200/50">
                        <strong className="text-orange-900 block text-[10px] uppercase">Primary CTA:</strong>
                        <span className="text-slate-700 truncate block">{slide.primaryCta} ({slide.linkSlug || 'solutions'})</span>
                      </div>
                      <div className="bg-slate-50 p-2 rounded-lg border border-slate-200">
                        <strong className="text-slate-700 block text-[10px] uppercase">Secondary CTA:</strong>
                        <span className="text-slate-600 truncate block">{slide.secondaryCta}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-5 pt-0 flex items-center justify-between border-t border-slate-100 bg-slate-50/50">
                  <div className="flex gap-1">
                    <button
                      onClick={() => handleMoveSlide(idx, -1)}
                      disabled={idx === 0}
                      className="p-1.5 rounded-lg border hover:bg-slate-100 disabled:opacity-30 cursor-pointer"
                      title="Move Up"
                    >
                      <span className="material-symbols-outlined text-sm">arrow_upward</span>
                    </button>
                    <button
                      onClick={() => handleMoveSlide(idx, 1)}
                      disabled={idx === heroSlides.length - 1}
                      className="p-1.5 rounded-lg border hover:bg-slate-100 disabled:opacity-30 cursor-pointer"
                      title="Move Down"
                    >
                      <span className="material-symbols-outlined text-sm">arrow_downward</span>
                    </button>
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={() => setEditingSlide({ index: idx, data: { ...slide } })}
                      className="bg-slate-900 text-white font-sans text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-secondary cursor-pointer flex items-center gap-1"
                    >
                      <span className="material-symbols-outlined text-xs">edit</span>
                      <span>Edit Slide</span>
                    </button>
                    <button
                      onClick={() => handleDeleteSlide(idx)}
                      className="text-red-500 hover:text-red-700 p-1.5 rounded-lg hover:bg-red-50 cursor-pointer"
                      title="Delete Slide"
                    >
                      <span className="material-symbols-outlined text-base">delete</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* TAB 3.5: PROUDLY INDIAN PAGE */}
      {activeSubTab === 'india_page' && (
        <div className="space-y-6">
          <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm space-y-4">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">Proudly Indian Page CMS</h3>
              <p className="font-sans text-xs text-slate-500">Configure content for the national Make in India showcase page, background visuals, quote, and badge assets.</p>
            </div>
            
            <div className="space-y-4 text-xs font-sans">
              
              {/* Subtitle / Eyebrow */}
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Page Subtitle</label>
                <input
                  type="text"
                  value={indiaPage.subtitle || ''}
                  onChange={(e) => setIndiaPage({ ...indiaPage, subtitle: e.target.value })}
                  placeholder="Engineered in India, Empowering the World"
                  className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 rounded-xl font-bold"
                />
              </div>

              {/* Quote Statement */}
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Company Quote / Statement</label>
                <textarea
                  rows={4}
                  value={indiaPage.quote || ''}
                  onChange={(e) => setIndiaPage({ ...indiaPage, quote: e.target.value })}
                  placeholder="NOVATEK is an Indian company, driven by innovation..."
                  className="w-full px-3.5 py-2.5 bg-slate-50 border border-slate-200 rounded-xl leading-relaxed text-slate-700"
                />
              </div>

              {/* Background Visual */}
              <div className="space-y-2 border border-slate-100 p-4 rounded-2xl bg-slate-50/50">
                <label className="block font-mono font-bold text-slate-700">Background Hero Visual</label>
                {indiaPage.bgImage && (
                  <div className="h-32 w-full rounded-xl overflow-hidden bg-slate-900 border border-slate-200 relative mb-2">
                    <img
                      src={window.resolveMediaUrl(indiaPage.bgImage, 'banner')}
                      alt="Background Preview"
                      onError={(e) => window.handleImageError(e, 'banner')}
                      className="w-full h-full object-cover opacity-90"
                    />
                    <span className="absolute bottom-2 left-2 bg-slate-900/80 text-white text-[10px] px-2 py-0.5 rounded">
                      Background Banner Preview
                    </span>
                  </div>
                )}
                <div className="flex flex-wrap gap-2">
                  <input
                    type="text"
                    value={indiaPage.bgImage || ''}
                    onChange={(e) => setIndiaPage({ ...indiaPage, bgImage: e.target.value })}
                    placeholder="/api/storage/banners/india_hero_bg.jpg"
                    className="flex-1 min-w-[200px] px-3 py-2 bg-white border border-slate-200 rounded-xl font-mono"
                  />
                  <button
                    type="button"
                    onClick={() => setMediaPickerConfig({
                      isOpen: true,
                      title: 'Choose India Page Background Image',
                      onSelect: (url) => setIndiaPage({ ...indiaPage, bgImage: url })
                    })}
                    className="bg-white hover:bg-slate-100 text-slate-800 font-sans text-xs font-bold px-3 py-2 rounded-xl border border-slate-200 transition-all flex items-center gap-1 shrink-0 cursor-pointer shadow-2xs"
                  >
                    <span className="material-symbols-outlined text-sm text-secondary">photo_library</span>
                    <span>Choose from Media</span>
                  </button>
                  <label className="bg-slate-900 hover:bg-secondary text-white font-sans text-xs font-bold px-3 py-2 rounded-xl cursor-pointer transition-colors flex items-center gap-1 shrink-0 shadow-2xs">
                    <span className="material-symbols-outlined text-sm">upload</span>
                    <span>Upload Image</span>
                    <input 
                      type="file" 
                      accept="image/*" 
                      className="hidden" 
                      onChange={(e) => handleUploadImage(e, (url) => setIndiaPage({ ...indiaPage, bgImage: url }))} 
                    />
                  </label>
                </div>
              </div>

              {/* Lion Logo / Make in India Badge */}
              <div className="space-y-2 border border-slate-100 p-4 rounded-2xl bg-slate-50/50">
                <label className="block font-mono font-bold text-slate-700">Make in India / Badge Asset</label>
                {indiaPage.lionLogo && (
                  <div className="h-28 w-28 rounded-xl overflow-hidden bg-white border border-slate-200 p-2 flex items-center justify-center mb-2">
                    <img
                      src={window.resolveMediaUrl(indiaPage.lionLogo, 'banner')}
                      alt="Badge Preview"
                      onError={(e) => window.handleImageError(e, 'banner')}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                )}
                <div className="flex flex-wrap gap-2">
                  <input
                    type="text"
                    value={indiaPage.lionLogo || ''}
                    onChange={(e) => setIndiaPage({ ...indiaPage, lionLogo: e.target.value })}
                    placeholder="/make_in_india_lion.png"
                    className="flex-1 min-w-[200px] px-3 py-2 bg-white border border-slate-200 rounded-xl font-mono"
                  />
                  <button
                    type="button"
                    onClick={() => setMediaPickerConfig({
                      isOpen: true,
                      title: 'Choose India Page Lion Logo',
                      onSelect: (url) => setIndiaPage({ ...indiaPage, lionLogo: url })
                    })}
                    className="bg-white hover:bg-slate-100 text-slate-800 font-sans text-xs font-bold px-3 py-2 rounded-xl border border-slate-200 transition-all flex items-center gap-1 shrink-0 cursor-pointer shadow-2xs"
                  >
                    <span className="material-symbols-outlined text-sm text-secondary">photo_library</span>
                    <span>Choose from Media</span>
                  </button>
                  <label className="bg-slate-900 hover:bg-secondary text-white font-sans text-xs font-bold px-3 py-2 rounded-xl cursor-pointer transition-colors flex items-center gap-1 shrink-0 shadow-2xs">
                    <span className="material-symbols-outlined text-sm">upload</span>
                    <span>Upload Image</span>
                    <input 
                      type="file" 
                      accept="image/*" 
                      className="hidden" 
                      onChange={(e) => handleUploadImage(e, (url) => setIndiaPage({ ...indiaPage, lionLogo: url }))} 
                    />
                  </label>
                </div>
              </div>

            </div>

            {/* Save Button */}
            <div className="flex justify-end pt-3 border-t">
              <button
                onClick={() => saveSection('india_page', indiaPage, 'Proudly Indian page content updated successfully!')}
                className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-6 py-2.5 rounded-xl shadow shadow-orange-500/20 cursor-pointer flex items-center gap-1.5"
              >
                <span className="material-symbols-outlined text-sm">save</span>
                <span>Save India Page Content</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* TAB 4: CLIENT LOGOS */}
      {activeSubTab === 'home_clients' && (
        <div className="space-y-6">
          <div className="bg-white p-4 rounded-2xl border border-slate-200">
            <h3 className="font-sans text-sm font-bold text-slate-900">Client Partner Organizations</h3>
            <p className="font-sans text-xs text-slate-500">Manage client logos, names, and descriptions categorized across the 4 key industry sectors.</p>
          </div>

          {['railways', 'automotive', 'rd', 'aerospace'].map((sectorKey) => {
            const list = clientsData[sectorKey] || [];
            const sectorTitles = {
              railways: 'Railways (Indian Railways, Alstom, Wabtec...)',
              automotive: 'Automotive & EV (TVS, Renault Nissan, Uno Minda...)',
              rd: 'R&D & Premier Academia (CSIR-NAL, IISc, IIT Madras...)',
              aerospace: 'Aerospace & Defence (Air Works, Aviation...)'
            };

            return (
              <div key={sectorKey} className="bg-white p-5 rounded-2xl border border-slate-200 space-y-4 shadow-sm">
                <div className="flex justify-between items-center border-b pb-3">
                  <div>
                    <h4 className="font-sans text-sm font-bold text-slate-900 uppercase tracking-wide">
                      {sectorTitles[sectorKey] || sectorKey}
                    </h4>
                    <span className="text-xs font-sans text-slate-500">{list.length} organizations listed</span>
                  </div>
                  <button
                    onClick={() => setEditingClient({
                      sector: sectorKey,
                      data: { name: '', description: '', logo: '/api/storage/clients/indian_railways.png' }
                    })}
                    className="bg-slate-900 hover:bg-secondary text-white font-sans text-xs font-bold px-3 py-1.5 rounded-lg flex items-center gap-1"
                  >
                    <span className="material-symbols-outlined text-sm">add</span>
                    <span>Add Client</span>
                  </button>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {list.map((client, idx) => (
                    <div key={idx} className="p-3 rounded-xl border border-slate-200 bg-slate-50 flex items-center justify-between gap-3">
                      <div className="flex items-center gap-3 overflow-hidden">
                        <div className="h-12 w-12 bg-white rounded-lg p-1 border flex items-center justify-center shrink-0">
                          <img
                            src={window.resolveMediaUrl(client.logo, 'client')}
                            alt={client.name}
                            onError={(e) => window.handleImageError(e, 'client')}
                            className="max-h-full max-w-full object-contain"
                          />
                        </div>
                        <div className="truncate">
                          <h5 className="font-sans text-xs font-bold text-slate-900 truncate">{client.name}</h5>
                          <p className="font-sans text-[11px] text-slate-500 truncate">{client.description || 'Client Organization'}</p>
                        </div>
                      </div>

                      <div className="flex gap-1 shrink-0">
                        <button
                          onClick={() => setEditingClient({ sector: sectorKey, index: idx, data: { ...client } })}
                          className="p-1 rounded hover:bg-slate-200 text-slate-700"
                        >
                          <span className="material-symbols-outlined text-sm">edit</span>
                        </button>
                        <button
                          onClick={() => handleDeleteClient(sectorKey, idx)}
                          className="p-1 rounded hover:bg-red-100 text-red-500"
                        >
                          <span className="material-symbols-outlined text-sm">delete</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* TAB 5: LEADERSHIP & TEAM */}
      {activeSubTab === 'about_team' && (
        <div className="space-y-6">
          <div className="flex justify-between items-center bg-white p-4 rounded-2xl border border-slate-200">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">Leadership & Engineering Team</h3>
              <p className="font-sans text-xs text-slate-500">Showcase your principal engineers, credentials, departments, and bios on the About Page.</p>
            </div>
            <button
              onClick={() => setEditingMember({
                data: {
                  name: "",
                  role: "Principal Engineer",
                  credentials: "B.Tech / M.Tech • 10+ Yrs Exp",
                  department: "Engineering Design",
                  photo: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=600&q=80",
                  bio: "Domain expert in custom test rigs and high-precision automation systems."
                }
              })}
              className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-4 py-2 rounded-xl flex items-center gap-1.5 shadow"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add Team Member</span>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {teamMembers.map((member, idx) => (
              <div key={idx} className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3 shadow-sm hover:shadow-md transition-all flex flex-col justify-between">
                <div className="flex gap-4 items-start">
                  <div className="h-16 w-16 rounded-xl overflow-hidden bg-slate-100 border shrink-0">
                    <img
                      src={window.resolveMediaUrl(member.photo, 'client')}
                      alt={member.name}
                      onError={(e) => window.handleImageError(e, 'client')}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="space-y-1 min-w-0">
                    <h4 className="font-sans text-base font-bold text-slate-900 truncate">{member.name}</h4>
                    <p className="font-sans text-xs font-semibold text-secondary">{member.role}</p>
                    <p className="font-sans text-[11px] text-slate-500">{member.credentials}</p>
                  </div>
                </div>

                <p className="font-sans text-xs text-slate-600 line-clamp-2">{member.bio}</p>

                <div className="flex items-center justify-between pt-3 border-t border-slate-100">
                  <div className="flex gap-1">
                    <button
                      onClick={() => handleMoveMember(idx, -1)}
                      disabled={idx === 0}
                      className="p-1.5 rounded-lg border hover:bg-slate-100 disabled:opacity-30"
                    >
                      <span className="material-symbols-outlined text-sm">arrow_upward</span>
                    </button>
                    <button
                      onClick={() => handleMoveMember(idx, 1)}
                      disabled={idx === teamMembers.length - 1}
                      className="p-1.5 rounded-lg border hover:bg-slate-100 disabled:opacity-30"
                    >
                      <span className="material-symbols-outlined text-sm">arrow_downward</span>
                    </button>
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={() => setEditingMember({ index: idx, data: { ...member } })}
                      className="bg-slate-900 text-white font-sans text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-secondary cursor-pointer"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteMember(idx)}
                      className="text-red-500 hover:text-red-700 p-1.5 rounded-lg hover:bg-red-50 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-base">delete</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* TAB 6: 8-STAGE ENGINEERING PROCESS */}
      {activeSubTab === 'home_process' && (
        <div className="space-y-6">
          <div className="flex justify-between items-center bg-white p-4 rounded-2xl border border-slate-200">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">8-Stage Engineering Process</h3>
              <p className="font-sans text-xs text-slate-500">The end-to-end milestone lifecycle displayed on the homepage.</p>
            </div>
            <button
              onClick={() => setEditingStep({
                data: { step: `0${processSteps.length + 1}`, title: "New Milestone", description: "Milestone scope and deliverables..." }
              })}
              className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-4 py-2 rounded-xl flex items-center gap-1.5 shadow"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add Milestone</span>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {processSteps.map((step, idx) => (
              <div key={idx} className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3 shadow-sm hover:shadow-md transition-all flex flex-col justify-between">
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <span className="h-6 w-8 rounded bg-orange-100 text-secondary font-mono font-bold text-xs flex items-center justify-center">
                      {step.step}
                    </span>
                    <h4 className="font-sans text-sm font-bold text-slate-900">{step.title}</h4>
                  </div>
                  <p className="font-sans text-xs text-slate-600">{step.description}</p>
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-slate-100">
                  <div className="flex gap-1">
                    <button
                      onClick={() => handleMoveStep(idx, -1)}
                      disabled={idx === 0}
                      className="p-1 rounded border hover:bg-slate-100 disabled:opacity-30"
                    >
                      <span className="material-symbols-outlined text-xs">arrow_upward</span>
                    </button>
                    <button
                      onClick={() => handleMoveStep(idx, 1)}
                      disabled={idx === processSteps.length - 1}
                      className="p-1 rounded border hover:bg-slate-100 disabled:opacity-30"
                    >
                      <span className="material-symbols-outlined text-xs">arrow_downward</span>
                    </button>
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={() => setEditingStep({ index: idx, data: { ...step } })}
                      className="bg-slate-900 text-white font-sans text-xs font-bold px-3 py-1 rounded-lg hover:bg-secondary cursor-pointer"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteStep(idx)}
                      className="text-red-500 hover:text-red-700 p-1 rounded-lg hover:bg-red-50 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-base">delete</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* TAB 7: POSITIONING & STATS */}
      {activeSubTab === 'home_positioning' && (
        <div className="bg-white p-6 rounded-2xl border border-slate-200 space-y-6 shadow-sm">
          <div className="border-b pb-4">
            <h3 className="font-sans text-base font-bold text-slate-900">Brand Positioning & Metric Counters</h3>
            <p className="font-sans text-xs text-slate-500">Core message statement and statistics displayed across the website.</p>
          </div>

          <div className="space-y-4 text-xs font-sans">
            <div>
              <label className="block font-mono font-bold text-slate-700 mb-1">Eyebrow Tagline</label>
              <input
                type="text"
                value={positioning.eyebrow}
                onChange={(e) => setPositioning({ ...positioning, eyebrow: e.target.value })}
                className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
              />
            </div>

            <div>
              <label className="block font-mono font-bold text-slate-700 mb-1">Primary H1 Headline</label>
              <input
                type="text"
                value={positioning.h1}
                onChange={(e) => setPositioning({ ...positioning, h1: e.target.value })}
                className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
              />
            </div>

            <div>
              <label className="block font-mono font-bold text-slate-700 mb-1">Mission Statement</label>
              <textarea
                rows={3}
                value={positioning.statement}
                onChange={(e) => setPositioning({ ...positioning, statement: e.target.value })}
                className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
              />
            </div>

            <div className="pt-4 border-t">
              <label className="block font-mono font-bold text-slate-700 mb-3">Live Statistics Numbers</label>
              <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
                {Object.keys(positioning.stats || {}).map((statKey) => (
                  <div key={statKey}>
                    <label className="block text-[11px] font-mono text-slate-500 uppercase">{statKey}</label>
                    <input
                      type="text"
                      value={positioning.stats[statKey]}
                      onChange={(e) => setPositioning({
                        ...positioning,
                        stats: { ...positioning.stats, [statKey]: e.target.value }
                      })}
                      className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end pt-4">
              <button
                onClick={() => saveSection('home_positioning', positioning, 'Positioning & Stats updated!')}
                className="bg-secondary text-white font-sans text-xs font-bold px-6 py-2.5 rounded-xl shadow cursor-pointer"
              >
                Save Positioning & Stats
              </button>
            </div>
          </div>
        </div>
      )}

      {/* TAB 8: ENGINEERING FAQS */}
      {activeSubTab === 'about_faqs' && (
        <div className="space-y-6">
          <div className="flex justify-between items-center bg-white p-4 rounded-2xl border border-slate-200">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">Engineering FAQs</h3>
              <p className="font-sans text-xs text-slate-500">Technical questions answered on the About Page.</p>
            </div>
            <button
              onClick={() => setEditingFaq({ data: { question: "", answer: "" } })}
              className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-4 py-2 rounded-xl flex items-center gap-1.5 shadow"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add FAQ</span>
            </button>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-white p-4 rounded-2xl border border-slate-200 space-y-2">
                <div className="flex justify-between items-start">
                  <h4 className="font-sans text-sm font-bold text-slate-900">Q: {faq.question}</h4>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setEditingFaq({ index: idx, data: { ...faq } })}
                      className="text-slate-600 hover:text-slate-900 font-sans text-xs font-bold"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteFaq(idx)}
                      className="text-red-500 hover:text-red-700 font-sans text-xs font-bold"
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <p className="font-sans text-xs text-slate-600 leading-relaxed">A: {faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* TAB 9: CONTACT & FOOTER */}
      {activeSubTab === 'contact_footer' && (
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-2xl border border-slate-200 space-y-6 shadow-sm">
            <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 border-b pb-4">
              <div>
                <h3 className="font-sans text-lg font-bold text-slate-900">Contact & Footer Address Details</h3>
                <p className="font-mono text-[11px] text-slate-400 mt-1">Updates address, phone lines, and email addresses shown on the Contact page & global footer.</p>
              </div>
              <button
                onClick={() => saveSection('contact_info', contactInfo, 'Contact info updated!')}
                className="bg-[#f97316] hover:bg-[#ea580c] text-white font-mono text-[10px] uppercase font-bold tracking-wider px-5 py-2.5 rounded-lg shadow-sm transition-colors shrink-0"
              >
                SAVE CONTACT DETAILS
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-xs font-sans">
              <div className="sm:col-span-2">
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">HEADQUARTERS ADDRESS</label>
                <input
                  type="text"
                  value={contactInfo.address}
                  onChange={(e) => setContactInfo({ ...contactInfo, address: e.target.value })}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 font-mono text-xs focus:outline-none focus:border-slate-400 focus:bg-white transition-colors"
                />
              </div>

              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">PRIMARY PHONE NUMBER</label>
                <input
                  type="text"
                  value={contactInfo.phone}
                  onChange={(e) => setContactInfo({ ...contactInfo, phone: e.target.value })}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 font-mono text-xs focus:outline-none focus:border-slate-400 focus:bg-white transition-colors"
                />
              </div>

              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">SECONDARY PHONE NUMBER</label>
                <input
                  type="text"
                  value={contactInfo.phone2}
                  onChange={(e) => setContactInfo({ ...contactInfo, phone2: e.target.value })}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 font-mono text-xs focus:outline-none focus:border-slate-400 focus:bg-white transition-colors"
                />
              </div>

              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">PRIMARY EMAIL ADDRESS</label>
                <input
                  type="text"
                  value={contactInfo.email}
                  onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 font-mono text-xs focus:outline-none focus:border-slate-400 focus:bg-white transition-colors"
                />
              </div>

              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">SECONDARY EMAIL ADDRESS</label>
                <input
                  type="text"
                  value={contactInfo.supportEmail}
                  onChange={(e) => setContactInfo({ ...contactInfo, supportEmail: e.target.value })}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 font-mono text-xs focus:outline-none focus:border-slate-400 focus:bg-white transition-colors"
                />
              </div>

              <div className="sm:col-span-2">
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">BUSINESS OPERATIONAL HOURS</label>
                <input
                  type="text"
                  value={contactInfo.workingHours}
                  onChange={(e) => setContactInfo({ ...contactInfo, workingHours: e.target.value })}
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-slate-700 font-mono text-xs focus:outline-none focus:border-slate-400 focus:bg-white transition-colors"
                />
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl border border-slate-200 space-y-4 shadow-sm">
            <h3 className="font-sans text-base font-bold text-slate-900 border-b pb-3">Footer Legal & Tagline</h3>
            <div className="space-y-3 text-xs font-sans">
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Footer Tagline</label>
                <input
                  type="text"
                  value={footerInfo.tagline}
                  onChange={(e) => setFooterInfo({ ...footerInfo, tagline: e.target.value })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Legal Copyright Line</label>
                <input
                  type="text"
                  value={footerInfo.legal}
                  onChange={(e) => setFooterInfo({ ...footerInfo, legal: e.target.value })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>
            </div>
            <div className="flex justify-end pt-2">
              <button
                onClick={() => saveSection('footer_info', footerInfo, 'Footer info updated!')}
                className="bg-secondary text-white font-sans text-xs font-bold px-6 py-2 rounded-xl shadow cursor-pointer"
              >
                Save Footer Info
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* MODALS */}
      {/* ========================================================================= */}

      {/* 0. NAVBAR ITEM MODAL */}
      {editingNavItem && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-lg w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingNavItem.index !== undefined ? 'Edit Navigation Item' : 'Add Navigation Item'}
              </h3>
              <button onClick={() => setEditingNavItem(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans">
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Menu Label</label>
                <input
                  type="text"
                  value={editingNavItem.data.label}
                  onChange={(e) => setEditingNavItem({ ...editingNavItem, data: { ...editingNavItem.data, label: e.target.value } })}
                  placeholder="e.g. Solutions, Products, About"
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Target Tab Slug</label>
                  <input
                    type="text"
                    value={editingNavItem.data.target}
                    onChange={(e) => setEditingNavItem({ ...editingNavItem, data: { ...editingNavItem.data, target: e.target.value } })}
                    placeholder="e.g. solutions, products, contact"
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                  />
                </div>
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Type</label>
                  <select
                    value={editingNavItem.data.type || 'link'}
                    onChange={(e) => setEditingNavItem({ ...editingNavItem, data: { ...editingNavItem.data, type: e.target.value } })}
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-mono text-xs"
                  >
                    <option value="link">Direct Link</option>
                    <option value="dropdown">Dropdown Menu</option>
                  </select>
                </div>
              </div>

              {editingNavItem.data.type === 'dropdown' && (
                <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-mono text-xs font-bold uppercase text-slate-800">Dropdown Sub-Links</span>
                    <button
                      type="button"
                      onClick={() => setEditingNavItem({
                        ...editingNavItem,
                        data: {
                          ...editingNavItem.data,
                          items: [...(editingNavItem.data.items || []), { id: `sub-${Date.now()}`, label: '', target: '', visible: true }]
                        }
                      })}
                      className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                    >
                      + Add Sub-Link
                    </button>
                  </div>
                  <div className="space-y-3">
                    {(editingNavItem.data.items || []).map((subItem, idx) => (
                      <div key={idx} className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto]">
                        <div className="flex flex-col gap-2">
                          <select 
                            className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none bg-white font-bold cursor-pointer"
                            onChange={(e) => {
                              if (!e.target.value) return;
                              const [selectedLabel, selectedTarget] = e.target.value.split('|');
                              setEditingNavItem({
                                ...editingNavItem,
                                data: {
                                  ...editingNavItem.data,
                                  items: editingNavItem.data.items.map((item, index) => index === idx ? { ...item, label: selectedLabel, target: selectedTarget } : item)
                                }
                              });
                              e.target.value = ""; // Reset select after picking
                            }}
                          >
                            <option value="">Auto-fill from available categories...</option>
                            <optgroup label="Intelligent Engineering CMS">
                              {solutionsData.map(s => <option key={s.id} value={`${s.title}|${s.slug || s.id}`}>{s.title}</option>)}
                            </optgroup>
                            <optgroup label="Industries CMS">
                              {industriesData.map(i => <option key={i.id} value={`${i.title}|${i.slug || i.id}`}>{i.title}</option>)}
                            </optgroup>
                            <optgroup label="Products Catalog Categories">
                              {productCategories.map(c => (
                                <option key={c.id} value={`${c.name}|products:${c.name}`}>
                                  {c.name}
                                </option>
                              ))}
                            </optgroup>
                            <optgroup label="Standard Website Pages">
                              <option value="Products Portfolio|products">Products Portfolio</option>
                              <option value="Projects Gallery|projects">Projects Gallery</option>
                              <option value="Technical Blogs|blogs">Technical Blogs</option>
                              <option value="Careers|careers">Careers</option>
                              <option value="Downloads|downloads">Downloads</option>
                              <option value="About Us|about">About Us</option>
                              <option value="Contact Us|contact">Contact Us</option>
                              <option value="Support|support">Support</option>
                            </optgroup>
                          </select>
                          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                            <input
                              type="text"
                              value={subItem.label || ''}
                              onChange={(e) => setEditingNavItem({
                                ...editingNavItem,
                                data: {
                                  ...editingNavItem.data,
                                  items: editingNavItem.data.items.map((item, index) => index === idx ? { ...item, label: e.target.value } : item)
                                }
                              })}
                              placeholder="Sub-Link Label"
                              className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                            />
                            <input
                              type="text"
                              value={subItem.target || ''}
                              onChange={(e) => setEditingNavItem({
                                ...editingNavItem,
                                data: {
                                  ...editingNavItem.data,
                                  items: editingNavItem.data.items.map((item, index) => index === idx ? { ...item, target: e.target.value } : item)
                                }
                              })}
                              placeholder="Target Slug (e.g. railway-testing)"
                              className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => setEditingNavItem({
                            ...editingNavItem,
                            data: {
                              ...editingNavItem.data,
                              items: editingNavItem.data.items.filter((_, index) => index !== idx)
                            }
                          })}
                          className="self-center text-red-500 hover:text-red-700 text-xs font-bold px-2 py-1 rounded hover:bg-red-50"
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                    {(editingNavItem.data.items || []).length === 0 && (
                      <p className="text-[11px] text-slate-500">Add sub-links for this dropdown menu.</p>
                    )}
                  </div>

                  {/* Create New Category Shortcuts */}
                  <div className="pt-3 border-t border-slate-200 flex flex-wrap gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        setEditingNavItem(null);
                        setActiveSubTab('solutions_data');
                        setEditingSolution({ index: undefined, data: { id: `sol-${Date.now()}`, title: '', visible: true } });
                      }}
                      className="px-3 py-1.5 bg-white border border-slate-300 rounded-lg text-[10px] font-bold text-slate-700 hover:text-secondary hover:border-secondary transition-colors flex items-center gap-1 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-[14px]">add_circle</span>
                      Create Engineering Category
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setEditingNavItem(null);
                        setActiveSubTab('industries_data');
                        setEditingIndustry({ index: undefined, data: { id: `ind-${Date.now()}`, title: '', visible: true } });
                      }}
                      className="px-3 py-1.5 bg-white border border-slate-300 rounded-lg text-[10px] font-bold text-slate-700 hover:text-secondary hover:border-secondary transition-colors flex items-center gap-1 cursor-pointer"
                    >
                      <span className="material-symbols-outlined text-[14px]">add_circle</span>
                      Create Industry
                    </button>
                  </div>
                </div>
              )}

              <div>
                <label className="flex items-center gap-2 cursor-pointer font-bold text-slate-800">
                  <input
                    type="checkbox"
                    checked={editingNavItem.data.visible !== false}
                    onChange={(e) => setEditingNavItem({ ...editingNavItem, data: { ...editingNavItem.data, visible: e.target.checked } })}
                    className="h-4 w-4 rounded text-secondary"
                  />
                  <span>Show this option on the website navigation bar</span>
                </label>
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingNavItem(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveNavItem} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save Menu Item</button>
            </div>
          </div>
        </div>
      )}

      {/* 1. SOLUTION MODAL */}
      {editingSolution && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-2xl w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingSolution.index !== undefined ? 'Edit Category' : 'Add New Category'}
              </h3>
              <button onClick={() => setEditingSolution(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Category Title</label>
                  <input
                    type="text"
                    value={editingSolution.data.title}
                    onChange={(e) => setEditingSolution({ ...editingSolution, data: { ...editingSolution.data, title: e.target.value } })}
                    placeholder="e.g. Custom Test Rigs & Test Benches"
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                  />
                </div>
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Eyebrow Tag</label>
                  <input
                    type="text"
                    value={editingSolution.data.eyebrow || ''}
                    onChange={(e) => setEditingSolution({ ...editingSolution, data: { ...editingSolution.data, eyebrow: e.target.value } })}
                    placeholder="e.g. PRECISION VALIDATION SYSTEMS"
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                  />
                </div>
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">URL Slug</label>
                <input
                  type="text"
                  value={editingSolution.data.slug || editingSolution.data.id}
                  onChange={(e) => setEditingSolution({ ...editingSolution, data: { ...editingSolution.data, slug: e.target.value, id: e.target.value } })}
                  placeholder="e.g. custom-test-rigs"
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-mono"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Short Description</label>
                <textarea
                  rows={2}
                  value={editingSolution.data.shortDesc || ''}
                  onChange={(e) => setEditingSolution({ ...editingSolution, data: { ...editingSolution.data, shortDesc: e.target.value } })}
                  placeholder="Short summary for cards..."
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Hero Description</label>
                <textarea
                  rows={3}
                  value={editingSolution.data.heroDesc || ''}
                  onChange={(e) => setEditingSolution({ ...editingSolution, data: { ...editingSolution.data, heroDesc: e.target.value } })}
                  placeholder="Detailed engineering positioning..."
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="flex items-center gap-2 cursor-pointer font-bold text-slate-800">
                  <input
                    type="checkbox"
                    checked={editingSolution.data.visible !== false}
                    onChange={(e) => setEditingSolution({ ...editingSolution, data: { ...editingSolution.data, visible: e.target.checked } })}
                    className="h-4 w-4 rounded text-secondary"
                  />
                  <span>Show this category on the website</span>
                </label>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs font-bold uppercase text-slate-800">Test Types / Validation Scope</span>
                  <button
                    type="button"
                    onClick={() => setEditingSolution({
                      ...editingSolution,
                      data: {
                        ...editingSolution.data,
                        testTypes: [...(editingSolution.data.testTypes || []), { name: '', desc: '' }]
                      }
                    })}
                    className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                  >
                    + Add Test Type
                  </button>
                </div>
                <div className="space-y-3">
                  {(editingSolution.data.testTypes || []).map((type, idx) => (
                    <div key={idx} className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto]">
                      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <input
                          type="text"
                          value={type.name || ''}
                          onChange={(e) => setEditingSolution({
                            ...editingSolution,
                            data: {
                              ...editingSolution.data,
                              testTypes: editingSolution.data.testTypes.map((item, index) => index === idx ? { ...item, name: e.target.value } : item)
                            }
                          })}
                          placeholder="Test type title"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                        <input
                          type="text"
                          value={type.desc || ''}
                          onChange={(e) => setEditingSolution({
                            ...editingSolution,
                            data: {
                              ...editingSolution.data,
                              testTypes: editingSolution.data.testTypes.map((item, index) => index === idx ? { ...item, desc: e.target.value } : item)
                            }
                          })}
                          placeholder="Short description of the test scope"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => setEditingSolution({
                          ...editingSolution,
                          data: {
                            ...editingSolution.data,
                            testTypes: editingSolution.data.testTypes.filter((_, index) => index !== idx)
                          }
                        })}
                        className="self-center text-red-500 hover:text-red-700 text-xs font-bold"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {(editingSolution.data.testTypes || []).length === 0 && (
                    <p className="text-[11px] text-slate-500">Add one or more test type entries to define the validation scope.</p>
                  )}
                </div>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs font-bold uppercase text-slate-800">Technologies & Subsystems</span>
                  <button
                    type="button"
                    onClick={() => setEditingSolution({
                      ...editingSolution,
                      data: {
                        ...editingSolution.data,
                        technologies: [...(editingSolution.data.technologies || []), { title: '', desc: '' }]
                      }
                    })}
                    className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                  >
                    + Add Technology
                  </button>
                </div>
                <div className="space-y-3">
                  {(editingSolution.data.technologies || []).map((tech, idx) => (
                    <div key={idx} className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto]">
                      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <input
                          type="text"
                          value={tech.title || ''}
                          onChange={(e) => setEditingSolution({
                            ...editingSolution,
                            data: {
                              ...editingSolution.data,
                              technologies: editingSolution.data.technologies.map((item, index) => index === idx ? { ...item, title: e.target.value } : item)
                            }
                          })}
                          placeholder="Technology title"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                        <input
                          type="text"
                          value={tech.desc || ''}
                          onChange={(e) => setEditingSolution({
                            ...editingSolution,
                            data: {
                              ...editingSolution.data,
                              technologies: editingSolution.data.technologies.map((item, index) => index === idx ? { ...item, desc: e.target.value } : item)
                            }
                          })}
                          placeholder="Short description"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => setEditingSolution({
                          ...editingSolution,
                          data: {
                            ...editingSolution.data,
                            technologies: editingSolution.data.technologies.filter((_, index) => index !== idx)
                          }
                        })}
                        className="self-center text-red-500 hover:text-red-700 text-xs font-bold"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {(editingSolution.data.technologies || []).length === 0 && (
                    <p className="text-[11px] text-slate-500">Add one or more technology or subsystem entries linked to this solution.</p>
                  )}
                </div>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs font-bold uppercase text-slate-800">Related Product IDs</span>
                  <button
                    type="button"
                    onClick={() => setEditingSolution({
                      ...editingSolution,
                      data: {
                        ...editingSolution.data,
                        focusAreas: [...(editingSolution.data.focusAreas || []), '']
                      }
                    })}
                    className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                  >
                    + Add Focus Area
                  </button>
                </div>
                <div className="space-y-3">
                  {(editingSolution.data.focusAreas || []).map((prod, idx) => (
                    <div key={idx} className="flex gap-2 items-center">
                      <input
                        type="text"
                        value={prod || ''}
                        onChange={(e) => setEditingSolution({
                          ...editingSolution,
                          data: {
                            ...editingSolution.data,
                            focusAreas: editingSolution.data.focusAreas.map((item, index) => index === idx ? e.target.value : item)
                          }
                        })}
                        placeholder="Focus area description"
                        className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                      />
                      <button
                        type="button"
                        onClick={() => setEditingSolution({
                          ...editingSolution,
                          data: {
                            ...editingSolution.data,
                            focusAreas: editingSolution.data.focusAreas.filter((_, index) => index !== idx)
                          }
                        })}
                        className="text-red-500 hover:text-red-700 text-xs font-bold"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {(editingSolution.data.focusAreas || []).length === 0 && (
                    <p className="text-[11px] text-slate-500">Add the core focus points for this engineering category.</p>
                  )}
                </div>
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingSolution(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveSolution} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save Solution</button>
            </div>
          </div>
        </div>
      )}

      {/* 2. INDUSTRY MODAL */}
      {editingIndustry && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-2xl w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingIndustry.index !== undefined ? 'Edit Industry Sector' : 'Add New Industry Sector'}
              </h3>
              <button onClick={() => setEditingIndustry(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Sector Title</label>
                  <input
                    type="text"
                    value={editingIndustry.data.title}
                    onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, title: e.target.value } })}
                    placeholder="e.g. Railway Testing Systems & Rigs"
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                  />
                </div>
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Eyebrow Tag</label>
                  <input
                    type="text"
                    value={editingIndustry.data.eyebrow || ''}
                    onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, eyebrow: e.target.value } })}
                    placeholder="e.g. MISSION-CRITICAL RAIL"
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                  />
                </div>
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">URL Slug</label>
                <input
                  type="text"
                  value={editingIndustry.data.slug || editingIndustry.data.id}
                  onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, slug: e.target.value, id: e.target.value } })}
                  placeholder="e.g. railway, automotive, aerospace"
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-mono"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">H1 Main Headline</label>
                <input
                  type="text"
                  value={editingIndustry.data.h1 || editingIndustry.data.title}
                  onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, h1: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Hero Description</label>
                <textarea
                  rows={3}
                  value={editingIndustry.data.heroDesc || ''}
                  onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, heroDesc: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Sub-Sectors Section Title</label>
                <input
                  type="text"
                  placeholder="Default: Application Test Systems & Validation Modules"
                  value={editingIndustry.data.subSectorsTitle || ''}
                  onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, subSectorsTitle: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">View All Systems Target Category</label>
                <select
                  value={editingIndustry.data.viewAllCategory || ''}
                  onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, viewAllCategory: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl cursor-pointer"
                >
                  <option value="">-- Select Product Category (Default to splitting title) --</option>
                  {productCategories.map(c => (
                    <option key={c.id} value={c.name}>{c.name}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="flex items-center gap-2 cursor-pointer font-bold text-slate-800">
                  <input
                    type="checkbox"
                    checked={editingIndustry.data.visible !== false}
                    onChange={(e) => setEditingIndustry({ ...editingIndustry, data: { ...editingIndustry.data, visible: e.target.checked } })}
                    className="h-4 w-4 rounded text-secondary"
                  />
                  <span>Show this industry on the website</span>
                </label>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs font-bold uppercase text-slate-800">Sub-Sector Applications</span>
                  <button
                    type="button"
                    onClick={() => setEditingIndustry({
                      ...editingIndustry,
                      data: {
                        ...editingIndustry.data,
                        subSectors: [...(editingIndustry.data.subSectors || []), { title: '', desc: '', linkToProduct: '' }]
                      }
                    })}
                    className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                  >
                    + Add Sub-Sector
                  </button>
                </div>
                <div className="space-y-3">
                  {(editingIndustry.data.subSectors || []).map((sub, idx) => (
                    <div key={idx} className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto]">
                      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <input
                          type="text"
                          value={sub.title || ''}
                          onChange={(e) => setEditingIndustry({
                            ...editingIndustry,
                            data: {
                              ...editingIndustry.data,
                              subSectors: editingIndustry.data.subSectors.map((item, index) => index === idx ? { ...item, title: e.target.value } : item)
                            }
                          })}
                          placeholder="Sub-sector title"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                        <input
                          type="text"
                          value={sub.desc || ''}
                          onChange={(e) => setEditingIndustry({
                            ...editingIndustry,
                            data: {
                              ...editingIndustry.data,
                              subSectors: editingIndustry.data.subSectors.map((item, index) => index === idx ? { ...item, desc: e.target.value } : item)
                            }
                          })}
                          placeholder="Short description"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <input
                          type="text"
                          value={sub.linkToProduct || ''}
                          onChange={(e) => setEditingIndustry({
                            ...editingIndustry,
                            data: {
                              ...editingIndustry.data,
                              subSectors: editingIndustry.data.subSectors.map((item, index) => index === idx ? { ...item, linkToProduct: e.target.value } : item)
                            }
                          })}
                          placeholder="Product slug (optional)"
                          className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                        />
                        <button
                          type="button"
                          onClick={() => setEditingIndustry({
                            ...editingIndustry,
                            data: {
                              ...editingIndustry.data,
                              subSectors: editingIndustry.data.subSectors.filter((_, index) => index !== idx)
                            }
                          })}
                          className="self-end text-red-500 hover:text-red-700 text-xs font-bold"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                  {(editingIndustry.data.subSectors || []).length === 0 && (
                    <p className="text-[11px] text-slate-500">Add sub-sector application cards that appear on the industry page.</p>
                  )}
                </div>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs font-bold uppercase text-slate-800">Challenges Solved</span>
                  <button
                    type="button"
                    onClick={() => setEditingIndustry({
                      ...editingIndustry,
                      data: {
                        ...editingIndustry.data,
                        challengesSolved: [...(editingIndustry.data.challengesSolved || []), '']
                      }
                    })}
                    className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                  >
                    + Add Challenge
                  </button>
                </div>
                <div className="space-y-3">
                  {(editingIndustry.data.challengesSolved || []).map((challenge, idx) => (
                    <div key={idx} className="flex gap-2 items-center">
                      <input
                        type="text"
                        value={challenge || ''}
                        onChange={(e) => setEditingIndustry({
                          ...editingIndustry,
                          data: {
                            ...editingIndustry.data,
                            challengesSolved: editingIndustry.data.challengesSolved.map((item, index) => index === idx ? e.target.value : item)
                          }
                        })}
                        placeholder="Challenge statement"
                        className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                      />
                      <button
                        type="button"
                        onClick={() => setEditingIndustry({
                          ...editingIndustry,
                          data: {
                            ...editingIndustry.data,
                            challengesSolved: editingIndustry.data.challengesSolved.filter((_, index) => index !== idx)
                          }
                        })}
                        className="text-red-500 hover:text-red-700 text-xs font-bold"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {(editingIndustry.data.challengesSolved || []).length === 0 && (
                    <p className="text-[11px] text-slate-500">Add one or more core challenge statements for this sector.</p>
                  )}
                </div>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-200 space-y-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs font-bold uppercase text-slate-800">Featured Related Products</span>
                  <button
                    type="button"
                    onClick={() => setEditingIndustry({
                      ...editingIndustry,
                      data: {
                        ...editingIndustry.data,
                        featuredProducts: [...(editingIndustry.data.featuredProducts || []), '']
                      }
                    })}
                    className="text-xs font-mono font-bold text-secondary hover:text-orange-600"
                  >
                    + Add Product ID
                  </button>
                </div>
                <div className="space-y-3">
                  {(editingIndustry.data.featuredProducts || []).map((prod, idx) => (
                    <div key={idx} className="flex gap-2 items-center">
                      <input
                        type="text"
                        value={prod || ''}
                        onChange={(e) => setEditingIndustry({
                          ...editingIndustry,
                          data: {
                            ...editingIndustry.data,
                            featuredProducts: editingIndustry.data.featuredProducts.map((item, index) => index === idx ? e.target.value : item)
                          }
                        })}
                        placeholder="Product ID slug"
                        className="w-full p-2 text-xs border border-slate-300 rounded-xl outline-none"
                      />
                      <button
                        type="button"
                        onClick={() => setEditingIndustry({
                          ...editingIndustry,
                          data: {
                            ...editingIndustry.data,
                            featuredProducts: editingIndustry.data.featuredProducts.filter((_, index) => index !== idx)
                          }
                        })}
                        className="text-red-500 hover:text-red-700 text-xs font-bold"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {(editingIndustry.data.featuredProducts || []).length === 0 && (
                    <p className="text-[11px] text-slate-500">Enter featured product slugs to surface related machines on the industry page.</p>
                  )}
                </div>
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingIndustry(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveIndustry} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save Industry</button>
            </div>
          </div>
        </div>
      )}

      {/* 3. HERO SLIDE MODAL */}
      {editingSlide && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-2xl w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <div>
                <h3 className="font-sans text-base font-bold text-slate-900">
                  {editingSlide.index !== undefined ? `Edit Hero Slide #${editingSlide.index + 1}` : 'Add New Hero Slide'}
                </h3>
                <p className="font-sans text-xs text-slate-500">Configure hero messaging, challenge-solution callouts, and background visual.</p>
              </div>
              <button onClick={() => setEditingSlide(null)} className="text-slate-400 hover:text-slate-600 text-lg cursor-pointer">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-4 text-xs font-sans">
              
              {/* Sector Eyebrow & H1 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Eyebrow / Sector Title</label>
                  <input
                    type="text"
                    value={editingSlide.data.sector || ''}
                    onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, sector: e.target.value } })}
                    placeholder="e.g. RAILWAY TEST SYSTEMS"
                    className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold"
                  />
                </div>
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Target Link Slug</label>
                  <select
                    value={editingSlide.data.linkSlug || 'solutions'}
                    onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, linkSlug: e.target.value } })}
                    className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl"
                  >
                    <option value="solutions">Solutions Page</option>
                    <option value="railway">Railway Testing (Industries)</option>
                    <option value="automotive">Automotive Testing (Industries)</option>
                    <option value="aerospace">Aerospace Test Stands (Industries)</option>
                    <option value="products">Products Catalogue</option>
                    <option value="projects">Projects Portfolio</option>
                    <option value="contact">Contact / RFQ</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Primary H1 Headline</label>
                <input
                  type="text"
                  value={editingSlide.data.h1 || ''}
                  onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, h1: e.target.value } })}
                  placeholder="e.g. High-Speed Rail Brake & Component Dynamic Test Rigs"
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold text-sm"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Core Description Statement</label>
                <textarea
                  rows={2}
                  value={editingSlide.data.description || ''}
                  onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, description: e.target.value } })}
                  placeholder="Novatek designs and manufactures..."
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl leading-relaxed"
                />
              </div>



              {/* Action Buttons */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Primary Button Label</label>
                  <input
                    type="text"
                    value={editingSlide.data.primaryCta || ''}
                    onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, primaryCta: e.target.value } })}
                    placeholder="e.g. Railway Testing Solutions"
                    className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl"
                  />
                </div>
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Secondary Button Label</label>
                  <input
                    type="text"
                    value={editingSlide.data.secondaryCta || ''}
                    onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, secondaryCta: e.target.value } })}
                    placeholder="e.g. Request Engineering Consultation"
                    className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl"
                  />
                </div>
              </div>

              {/* Background Image Upload & Media Picker */}
              <div className="space-y-2">
                <label className="block font-mono font-bold text-slate-700">Background Banner Image</label>
                
                {/* Live Image Preview */}
                {editingSlide.data.bgImage && (
                  <div className="h-28 w-full rounded-xl overflow-hidden bg-slate-900 relative border border-slate-200">
                    <img
                      src={window.resolveMediaUrl(editingSlide.data.bgImage, 'banner')}
                      alt="Preview"
                      onError={(e) => window.handleImageError(e, 'banner')}
                      className="w-full h-full object-cover opacity-90"
                    />
                    <span className="absolute bottom-2 left-2 bg-slate-900/80 text-white text-[10px] font-mono px-2 py-0.5 rounded">
                      Current Banner Preview
                    </span>
                  </div>
                )}

                <div className="flex flex-wrap gap-2">
                  <input
                    type="text"
                    value={editingSlide.data.bgImage || ''}
                    onChange={(e) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, bgImage: e.target.value } })}
                    placeholder="/api/storage/banners/hero_railways.png"
                    className="flex-1 min-w-[200px] px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-mono text-xs"
                  />
                  <button
                    type="button"
                    onClick={() => setMediaPickerConfig({
                      isOpen: true,
                      title: 'Choose Hero Slide Background Image',
                      onSelect: (url) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, bgImage: url } })
                    })}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-800 font-sans text-xs font-bold px-3.5 py-2 rounded-xl transition-all flex items-center gap-1.5 shrink-0 cursor-pointer shadow-2xs"
                  >
                    <span className="material-symbols-outlined text-sm text-secondary">photo_library</span>
                    <span>Choose from Media</span>
                  </button>
                  <label className="bg-slate-900 hover:bg-secondary text-white font-sans text-xs font-bold px-3.5 py-2 rounded-xl cursor-pointer transition-colors flex items-center gap-1.5 shrink-0 shadow-2xs">
                    <span className="material-symbols-outlined text-sm">upload</span>
                    <span>Upload Image</span>
                    <input 
                      type="file" 
                      accept="image/*" 
                      className="hidden" 
                      onChange={(e) => handleUploadImage(e, (url) => setEditingSlide({ ...editingSlide, data: { ...editingSlide.data, bgImage: url } }))} 
                    />
                  </label>
                </div>
              </div>

            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button 
                onClick={() => setEditingSlide(null)} 
                className="px-5 py-2.5 rounded-xl border border-slate-200 text-xs font-sans font-bold text-slate-600 hover:bg-slate-50 cursor-pointer"
              >
                Cancel
              </button>
              <button 
                onClick={handleSaveSlide} 
                className="px-6 py-2.5 rounded-xl bg-secondary hover:bg-orange-600 text-white text-xs font-sans font-bold shadow shadow-orange-500/20 cursor-pointer"
              >
                Save Hero Slide
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 4. CLIENT MODAL */}
      {editingClient && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-lg w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingClient.index !== undefined ? 'Edit Client Organization' : 'Add New Client Organization'}
              </h3>
              <button onClick={() => setEditingClient(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans">
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Target Sector</label>
                <select
                  value={editingClient.sector}
                  onChange={(e) => setEditingClient({ ...editingClient, sector: e.target.value })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-mono text-xs"
                >
                  <option value="railways">Railways (Indian Railways, Alstom, Wabtec...)</option>
                  <option value="automotive">Automotive & EV (TVS, Renault Nissan, Uno Minda...)</option>
                  <option value="rd">R&D & Academia (CSIR-NAL, IISc, IIT Madras...)</option>
                  <option value="aerospace">Aerospace & Defence (Air Works, Aviation...)</option>
                </select>
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Organization Name</label>
                <input
                  type="text"
                  value={editingClient.data.name}
                  onChange={(e) => setEditingClient({ ...editingClient, data: { ...editingClient.data, name: e.target.value } })}
                  placeholder="e.g. Alstom Transport"
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Short Description / Subtitle</label>
                <input
                  type="text"
                  value={editingClient.data.description || ''}
                  onChange={(e) => setEditingClient({ ...editingClient, data: { ...editingClient.data, description: e.target.value } })}
                  placeholder="e.g. Global Leader in Rail Mobility"
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Logo URL</label>
                <div className="flex flex-wrap gap-2">
                  <input
                    type="text"
                    value={editingClient.data.logo}
                    onChange={(e) => setEditingClient({ ...editingClient, data: { ...editingClient.data, logo: e.target.value } })}
                    className="flex-1 min-w-[180px] px-3 py-2 bg-slate-50 border rounded-xl text-xs"
                  />
                  <button
                    type="button"
                    onClick={() => setMediaPickerConfig({
                      isOpen: true,
                      title: 'Choose Client Organization Logo',
                      onSelect: (url) => setEditingClient({ ...editingClient, data: { ...editingClient.data, logo: url } })
                    })}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-800 font-sans text-xs font-bold px-3 py-2 rounded-xl transition-all flex items-center gap-1 shrink-0 cursor-pointer"
                  >
                    <span className="material-symbols-outlined text-sm text-secondary">photo_library</span>
                    <span>Choose from Media</span>
                  </button>
                  <label className="bg-slate-900 text-white font-sans text-xs font-bold px-3 py-2 rounded-xl cursor-pointer hover:bg-secondary flex items-center gap-1 shrink-0">
                    <span className="material-symbols-outlined text-sm">upload</span>
                    <span>Upload</span>
                    <input type="file" accept="image/*" className="hidden" onChange={(e) => handleUploadImage(e, (url) => setEditingClient({ ...editingClient, data: { ...editingClient.data, logo: url } }))} />
                  </label>
                </div>
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingClient(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveClient} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save Client</button>
            </div>
          </div>
        </div>
      )}

      {/* 5. TEAM MEMBER MODAL */}
      {editingMember && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-lg w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingMember.index !== undefined ? 'Edit Team Member' : 'Add Team Member'}
              </h3>
              <button onClick={() => setEditingMember(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Full Name</label>
                <input
                  type="text"
                  value={editingMember.data.name}
                  onChange={(e) => setEditingMember({ ...editingMember, data: { ...editingMember.data, name: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Role / Designation</label>
                  <input
                    type="text"
                    value={editingMember.data.role}
                    onChange={(e) => setEditingMember({ ...editingMember, data: { ...editingMember.data, role: e.target.value } })}
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                  />
                </div>

                <div>
                  <label className="block font-mono font-bold text-slate-700 mb-1">Department</label>
                  <input
                    type="text"
                    value={editingMember.data.department}
                    onChange={(e) => setEditingMember({ ...editingMember, data: { ...editingMember.data, department: e.target.value } })}
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                  />
                </div>
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Credentials / Experience</label>
                <input
                  type="text"
                  value={editingMember.data.credentials}
                  onChange={(e) => setEditingMember({ ...editingMember, data: { ...editingMember.data, credentials: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Bio Summary</label>
                <textarea
                  rows={3}
                  value={editingMember.data.bio}
                  onChange={(e) => setEditingMember({ ...editingMember, data: { ...editingMember.data, bio: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Photo URL</label>
                <div className="flex flex-wrap gap-2">
                  <input
                    type="text"
                    value={editingMember.data.photo}
                    onChange={(e) => setEditingMember({ ...editingMember, data: { ...editingMember.data, photo: e.target.value } })}
                    className="flex-1 min-w-[180px] px-3 py-2 bg-slate-50 border rounded-xl"
                  />
                  <button
                    type="button"
                    onClick={() => setMediaPickerConfig({
                      isOpen: true,
                      title: 'Choose Team Member Portrait Photo',
                      onSelect: (url) => setEditingMember({ ...editingMember, data: { ...editingMember.data, photo: url } })
                    })}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-800 font-sans text-xs font-bold px-3 py-2 rounded-xl transition-all flex items-center gap-1 shrink-0 cursor-pointer"
                  >
                    <span className="material-symbols-outlined text-sm text-secondary">photo_library</span>
                    <span>Choose from Media</span>
                  </button>
                  <label className="bg-slate-900 text-white font-sans text-xs font-bold px-3 py-2 rounded-xl cursor-pointer hover:bg-secondary flex items-center gap-1 shrink-0">
                    <span className="material-symbols-outlined text-sm">upload</span>
                    <span>Upload</span>
                    <input type="file" accept="image/*" className="hidden" onChange={(e) => handleUploadImage(e, (url) => setEditingMember({ ...editingMember, data: { ...editingMember.data, photo: url } }))} />
                  </label>
                </div>
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingMember(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveMember} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save Member</button>
            </div>
          </div>
        </div>
      )}

      {/* 6. PROCESS STEP MODAL */}
      {editingStep && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-lg w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingStep.index !== undefined ? `Edit Step #${editingStep.index + 1}` : 'Add Process Milestone'}
              </h3>
              <button onClick={() => setEditingStep(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans">
              <div className="grid grid-cols-4 gap-3">
                <div className="col-span-1">
                  <label className="block font-mono font-bold text-slate-700 mb-1">Step #</label>
                  <input
                    type="text"
                    value={editingStep.data.step}
                    onChange={(e) => setEditingStep({ ...editingStep, data: { ...editingStep.data, step: e.target.value } })}
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-mono font-bold"
                  />
                </div>
                <div className="col-span-3">
                  <label className="block font-mono font-bold text-slate-700 mb-1">Milestone Title</label>
                  <input
                    type="text"
                    value={editingStep.data.title}
                    onChange={(e) => setEditingStep({ ...editingStep, data: { ...editingStep.data, title: e.target.value } })}
                    className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                  />
                </div>
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Description</label>
                <textarea
                  rows={3}
                  value={editingStep.data.description}
                  onChange={(e) => setEditingStep({ ...editingStep, data: { ...editingStep.data, description: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingStep(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveStep} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save Step</button>
            </div>
          </div>
        </div>
      )}

      {/* 7. FAQ MODAL */}
      {editingFaq && (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6">
          <div className="bg-white rounded-3xl max-w-lg w-full flex flex-col max-h-[90vh] shadow-2xl">
            <div className="flex justify-between items-center border-b p-6 shrink-0">
              <h3 className="font-sans text-base font-bold text-slate-900">
                {editingFaq.index !== undefined ? 'Edit FAQ' : 'Add FAQ'}
              </h3>
              <button onClick={() => setEditingFaq(null)} className="text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar space-y-4">

            <div className="space-y-3 text-xs font-sans">
              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Question</label>
                <input
                  type="text"
                  value={editingFaq.data.question}
                  onChange={(e) => setEditingFaq({ ...editingFaq, data: { ...editingFaq.data, question: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl font-bold"
                />
              </div>

              <div>
                <label className="block font-mono font-bold text-slate-700 mb-1">Answer</label>
                <textarea
                  rows={4}
                  value={editingFaq.data.answer}
                  onChange={(e) => setEditingFaq({ ...editingFaq, data: { ...editingFaq.data, answer: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border rounded-xl"
                />
              </div>
            </div>

            </div>
            <div className="flex justify-end gap-3 p-6 border-t shrink-0 bg-slate-50 rounded-b-3xl">
              <button onClick={() => setEditingFaq(null)} className="px-4 py-2 rounded-xl border text-xs font-mono font-bold">Cancel</button>
              <button onClick={handleSaveFaq} className="px-5 py-2 rounded-xl bg-secondary text-white text-xs font-mono font-bold shadow">Save FAQ</button>
            </div>
          </div>
        </div>
      )}

      {/* TAB 12: ABOUT PAGE */}
      {activeSubTab === 'about_page' && (
        <div className="space-y-6">
          <div className="flex justify-between items-center bg-white p-4 rounded-2xl border border-slate-200">
            <div>
              <h3 className="font-sans text-sm font-bold text-slate-900">About Page Settings</h3>
              <p className="font-sans text-xs text-slate-500">Update the hero image, text, and core pillars displayed on the About Page.</p>
            </div>
            <button
              onClick={() => saveSection('about_page', aboutPage, 'About page saved successfully!')}
              className="bg-secondary hover:bg-orange-600 text-white font-sans text-xs font-bold px-5 py-2.5 rounded-xl shadow cursor-pointer"
            >
              Save About Page
            </button>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-6">
            <h4 className="font-sans text-sm font-bold text-slate-900 border-b pb-2">Hero Section</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Eyebrow Tag (Yellow)</label>
                <input
                  type="text"
                  value={aboutPage.hero.eyebrow}
                  onChange={(e) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, eyebrow: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold text-xs outline-none"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Main Headline (White Text)</label>
                <input
                  type="text"
                  value={aboutPage.hero.titleWhite}
                  onChange={(e) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, titleWhite: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold text-xs outline-none"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Secondary Headline Line 1 (Blue Text)</label>
                <input
                  type="text"
                  value={aboutPage.hero.titleBlueLine1}
                  onChange={(e) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, titleBlueLine1: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold text-xs outline-none text-blue-600"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Secondary Headline Line 2 (Blue Text)</label>
                <input
                  type="text"
                  value={aboutPage.hero.titleBlueLine2}
                  onChange={(e) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, titleBlueLine2: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold text-xs outline-none text-blue-600"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Description</label>
                <textarea
                  rows={3}
                  value={aboutPage.hero.description}
                  onChange={(e) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, description: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs outline-none"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Hero Background Image</label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={aboutPage.hero.bgImage}
                    onChange={(e) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, bgImage: e.target.value } })}
                    className="flex-1 px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs outline-none"
                  />
                  <button
                    onClick={() => setMediaPickerConfig({
                      isOpen: true,
                      title: 'Choose About Hero Background',
                      onSelect: (url) => setAboutPage({ ...aboutPage, hero: { ...aboutPage.hero, bgImage: url } })
                    })}
                    className="bg-slate-100 hover:bg-slate-200 font-bold px-3 py-2 rounded-xl text-xs flex items-center gap-1 cursor-pointer"
                  >
                    <span className="material-symbols-outlined text-sm">image</span>
                    Media
                  </button>
                </div>
              </div>
            </div>

            <h4 className="font-sans text-sm font-bold text-slate-900 border-b pb-2 mt-8">Core Pillars Section</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Section Title</label>
                <input
                  type="text"
                  value={aboutPage.pillars?.title || ''}
                  onChange={(e) => setAboutPage({ ...aboutPage, pillars: { ...aboutPage.pillars, title: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl font-bold text-xs outline-none"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Section Subtitle</label>
                <input
                  type="text"
                  value={aboutPage.pillars?.subtitle || ''}
                  onChange={(e) => setAboutPage({ ...aboutPage, pillars: { ...aboutPage.pillars, subtitle: e.target.value } })}
                  className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs outline-none"
                />
              </div>
            </div>
            
            <div className="space-y-4">
              {aboutPage.pillars?.items?.map((item, idx) => (
                <div key={idx} className="p-4 bg-slate-50 border border-slate-200 rounded-xl grid grid-cols-1 md:grid-cols-[auto_1fr_1fr] gap-4 items-start">
                  <div>
                    <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Icon (Material)</label>
                    <input
                      type="text"
                      value={item.icon}
                      onChange={(e) => {
                        const newItems = [...aboutPage.pillars.items];
                        newItems[idx].icon = e.target.value;
                        setAboutPage({ ...aboutPage, pillars: { ...aboutPage.pillars, items: newItems } });
                      }}
                      className="w-full px-2 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-mono"
                    />
                  </div>
                  <div>
                    <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Title</label>
                    <input
                      type="text"
                      value={item.title}
                      onChange={(e) => {
                        const newItems = [...aboutPage.pillars.items];
                        newItems[idx].title = e.target.value;
                        setAboutPage({ ...aboutPage, pillars: { ...aboutPage.pillars, items: newItems } });
                      }}
                      className="w-full px-2 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-bold"
                    />
                  </div>
                  <div>
                    <label className="block font-mono text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Description</label>
                    <textarea
                      rows={3}
                      value={item.description}
                      onChange={(e) => {
                        const newItems = [...aboutPage.pillars.items];
                        newItems[idx].description = e.target.value;
                        setAboutPage({ ...aboutPage, pillars: { ...aboutPage.pillars, items: newItems } });
                      }}
                      className="w-full px-2 py-1.5 bg-white border border-slate-200 rounded-lg text-xs"
                    />
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      )}

      {/* Reusable Global Media Picker */}
      {window.MediaPickerModal && (
        <window.MediaPickerModal
          isOpen={mediaPickerConfig.isOpen}
          title={mediaPickerConfig.title}
          onClose={() => setMediaPickerConfig({ ...mediaPickerConfig, isOpen: false })}
          onSelect={(url) => {
            if (mediaPickerConfig.onSelect) mediaPickerConfig.onSelect(url);
          }}
        />
      )}

    </div>
  );
};
